import { Grid } from '@mui/material';
import { PrimaryButton } from '../../theme/index'
import '../../sass/styles.scss';
import { UseScreen } from '../../hooks/UseScreen.hook';
import { useDispatch } from 'react-redux';
import { modalDeleteAction } from '../../redux/reducers/Modal';
import { deleteRoomAction } from '../../redux/reducers/Delete';

const Room = () => {

  const screenWidth = UseScreen();
  const dispatch = useDispatch();

  const deleteRoom = () => {
    dispatch(deleteRoomAction()); // delete from db.
    dispatch(modalDeleteAction());
  }

  return (
    <>
        <Grid item xs={ 10 }>
          {
            ( screenWidth > 500 ) ?
              <h5 style={{ margin: '0', marginBottom: '2rem' }}>Habitación / eliminar</h5>
            :
              <h6 style={{ margin: '0', marginBottom: '2rem' }}>Habitación / eliminar</h6>
          }
        </Grid>
        <Grid item xs={ 12 }textAlign='center'>
          {
            ( screenWidth > 500 ) ?
              <h3>Esta seguro que desea eliminar esta habitación?</h3>
            :
              <h6>Esta seguro que desea eliminar esta habitación?</h6>
          }
        </Grid>
        <Grid item xs={ 12 } sx={{ mt: 2 }} textAlign='center' className='pr-2'>
            <PrimaryButton onClick={ () => deleteRoom() } sx={{ width: '50%', boxShadow: 5 }}>Eliminar</PrimaryButton>
        </Grid>
    </>
  )
}

export default Room